import React, { useCallback, useMemo, useState } from 'react';
import { TiLocation } from 'react-icons/ti';

import {
  Container,
  SpanRow,
  List,
  ListItem,
  Badge,
  BadgeIcon,
  BadgeContent,
  BadgeTitle,
  BadgeDescription,
  Divider,
  Row,
  Column,
  VehicleArea,
  BadgeArea,
  ScoreLocation,
  BadgeAreaTitle,
} from './styles';

import Cautelar from '../../../../images/icons/badge_cautelar_aprovada.svg';
import CautelarInstaCarro from '../../../../images/icons/badge_instacarro_cautelar_aprovada.svg';
import Km from '../../../../images/icons/km.svg';
import Margem from './images/margem.svg';
import Giro from './images/giro.svg';
import Longarina from '../../../../images/icons/badge_longarina.svg';
import Colunas from '../../../../images/icons/badge_colunas.svg';
import Cambio from '../../../../images/icons/badge_cambio.svg';
import Scanner from '../../../../images/icons/badge_scanner.svg';
import UberRJ from '../../../../images/icons/badge_uber_rj.svg';
import UberSP from '../../../../images/icons/badge_uber_sp.svg';
import Uber from '../../../../images/icons/badge_uber.svg';
import Pneus from '../../../../images/icons/badge_bom_km.svg'; // Usando badge de km como placeholder temporário
import BadgePneus from '../../../../images/icons/badge_pneus.svg'; // Novo ícone para pneus
import BadgeInterior from '../../../../images/icons/badge_interior.svg'; // Novo ícone para conservação do interior
import BadgeGNV from '../../../../images/icons/badge_gnv.svg'; // Novo ícone para GNV
import BadgeBlindagem from '../../../../images/icons/badge_blindagem.svg'; // Novo ícone para blindagem

import { ReferencePrices } from '../ReferencePrices';
import { useFlag } from '@unleash/proxy-client-react';
import MaximumQuality from '../MaximumQuality';
import { DocumentResearch } from '../DocumentResearch';
import { DutLabel } from './styles';

const fuel = [
  'GASOLINA',
  'FLEX',
  'ETANOL',
  'DIESEL',
  'HIBRIDO',
  'HYBRID',
  'ELETRICO',
  'GASOLINA/GNV',
  'GASOLINA/ETANOL',
  'GASOLINA/ETANOL/GNV',
  'GASOLINA/ELETRICO',
  'GASOLINA/ETANOL/ELETRICO',
  'HYBRID FLEX',
  'HIBRIDO FLEX',
  'JETFLEX GASOLINA',
];

export const Summary = props => {
  const { auction, summary, marketPrice, updatedAuction } = props;
  const shouldShowFipeWebPrices = useFlag('ref-fipe-web-prices');

  const [size, setSize] = useState(window.screen.width);

  /** BADGEs UNLEASH FLAGS */
  const flagBadgeCautelar = useFlag('badge-cautelar');
  const flagBadgeLongarina = useFlag('badge-longarina');
  const flagBadgeColunas = useFlag('badge-colunas');
  const flagBadgeKm = useFlag('badge-km');
  const flagBadgeCambio = useFlag('badge-cambio');
  const flagBadgeScanner = useFlag('badge-scanner');
  const flagBadgeMargem = useFlag('badge-margem');
  const flagBadgeRevenda = useFlag('badge-giro');
  const flagBadgeUberSP = useFlag('badge-uber-sp');
  const flagBadgeUberRJ = useFlag('badge-uber-rj');
  const flagBadgeUberBoothStates = useFlag('badge-uber');
  const flagBadgePneus = useFlag('badge-pneus'); // Nova flag para badge de pneus
  const flagBadgeInterior = useFlag('badge-interior'); // Nova flag para badge de conservação do interior
  const flagBadgeGNV = useFlag('badge-gnv'); // Nova flag para badge de GNV
  const flagBadgeBlindagem = useFlag('badge-blindagem');

  const formmatDescription = description => {
    const parts = description.split(':');
    return parts.length >= 2 ? parts[1].trim() : '';
  };

  const injuctionNote = summary?.evaluation?.highlights?.map(({ icon, description }) =>
    icon === 11 ? description : null
  );

  const keySet = summary?.evaluation?.highlights?.map(({ icon, description }) =>
    icon === 12 ? formmatDescription(description) : null
  );

  const manualBooklet = summary?.evaluation?.highlights?.map(({ icon, description }) =>
    icon === 13 ? formmatDescription(description) : null
  );

  const shouldShowBadgeUberBoothStates =
    auction?.vehicle?.canHaveUberSPBadge &&
    auction?.vehicle?.canHaveUberRJBadge &&
    flagBadgeUberBoothStates;

  const shouldShowBadgeUberSP =
    auction?.vehicle?.canHaveUberSPBadge && flagBadgeUberSP && !shouldShowBadgeUberBoothStates;

  const shouldShowBadgeUberRJ =
    auction?.vehicle?.canHaveUberRJBadge && flagBadgeUberRJ && !shouldShowBadgeUberBoothStates;

  const shouldShowCautelar = auction?.vehicle?.precautionaryReport && flagBadgeCautelar;

  const shouldShowLongarina =
    auction?.vehicle?.canHaveCarSparBadge && flagBadgeLongarina && !shouldShowCautelar;

  const shouldShowColunas =
    auction?.vehicle?.canHaveColumnBadge && flagBadgeColunas && !shouldShowCautelar;

  // Nova lógica para badge de pneus
  const shouldShowPneus = auction?.vehicle?.canHaveTiresBadge && flagBadgePneus;

  // Nova lógica para badge de conservação do interior
  const shouldShowInterior = auction?.vehicle?.canHaveInteriorBadge && flagBadgeInterior;

  // Nova lógica para badge de GNV
  const shouldShowGNV = auction?.vehicle?.canHaveGNVBadge && flagBadgeGNV;

  const shouldShowBlindagem = auction?.vehicle?.canHaveBlindagemBadge && flagBadgeBlindagem;

  const BADGE_STATUS = {
    BadgeCautelar: shouldShowCautelar,
    BadgeLongarina: shouldShowLongarina,
    BadgeColunas: shouldShowColunas,
    BadgeBomKm: auction?.vehicle?.kilometrageAcceptable && flagBadgeKm,
    BadgeCambio: auction?.vehicle?.canHaveTransmissionBadge && flagBadgeCambio,
    BadgeScanner: auction?.vehicle?.canHaveScannerBadge && flagBadgeScanner,
    BadgeMargem: auction?.vehicle?.isBelowThreshold && flagBadgeMargem,
    BadgeRevenda: auction?.vehicle?.fastSpin && flagBadgeRevenda,
    BadgeUberSP: shouldShowBadgeUberSP,
    BadgeUberRJ: shouldShowBadgeUberRJ,
    BadgeUberBoothStates: shouldShowBadgeUberBoothStates,
    BadgePneus: shouldShowPneus, // Nova badge de pneus
    BadgeInterior: shouldShowInterior, // Nova badge de conservação do interior
    BadgeGNV: shouldShowGNV, // Nova badge de GNV
    BadgeBlindagem: shouldShowBlindagem, // Nova badge de blindagem
  };

  const getOrderedBadges = () => {
    // Definir ordem de prioridade das badges
    const badgeOrder = [
      'BadgeCautelar', // 1. Cautelar aprovada (mais alta prioridade)
      'BadgeLongarina', // 2. Longarina sem avarias
      'BadgeColunas', // 3. Coluna sem avarias
      'BadgeCambio', // 4. Câmbio sem apontamentos
      'BadgeScanner', // 5. Scanner sem apontamentos
      'BadgeInterior', // 6. Bom estado de conservação interior (NOVA)
      'BadgePneus', // 7. Pneus em condição de rodagem
      'BadgeBomKm', // 8. Boa km por ano
      'BadgeMargem', // 9. Margem alta revenda
      'BadgeRevenda', // 10. Giro rápido
      'BadgeUberBoothStates', // 11. Uber SP, RJ e outros
      'BadgeUberSP', // 12. Uber SP e outros
      'BadgeUberRJ', // 13. Uber RJ e outros
    ];

    // Aplicar regras de supressão
    let filteredBadges = Object.keys(BADGE_STATUS).filter(key => BADGE_STATUS[key]);

    // Regra 1: Se "Cautelar Aprovada" está presente, NÃO exibir "Longarina" e "Coluna"
    if (filteredBadges.includes('BadgeCautelar')) {
      filteredBadges = filteredBadges.filter(
        badge => !['BadgeLongarina', 'BadgeColunas'].includes(badge)
      );
    }
  };


  const BADGES = [
    {
      icone: auction?.vehicle?.hasD2D ? CautelarInstaCarro : Cautelar,
      titulo: auction?.vehicle?.hasD2D ? 'Cautelar aprovada' : 'Cautelar aprovada',
      descricao: auction?.vehicle?.hasD2D 
        ? 'Aprovada, pode conter apontamentos' 
        : 'Cautelar Visão total verificada e aprovada',
    },
    {
      icone: Longarina,
      titulo: 'Longarina sem apontamentos',
      descricao: 'Verificada e sem observações',
    },
    {
      icone: Colunas,
      titulo: 'Colunas sem apontamentos',
      descricao: 'Verificadas e sem observações',
    },
    {
      icone: Km,
      titulo: 'Boa km por ano',
      descricao: 'Na média de km para carros do mesmo ano',
    },
    {
      icone: Cambio,
      titulo: 'Câmbio sem apontamentos',
      descricao: 'Teste inerte sem ressalvas',
    },
    {
      icone: Scanner,
      titulo: 'Scanner sem apontamentos',
      descricao: 'Verificado e sem observações',
    },
    {
      icone: Margem,
      titulo: 'Margem alta na revenda',
      descricao: '70% abaixo do preço da web',
    },
    {
      icone: Giro,
      titulo: 'Giro rápido',
      descricao: 'Mais vendidos segundo a Fenabrave',
    },
    {
      icone: UberSP,
      titulo: 'Aceito no Uber Black SP e outros',
      descricao:
        'Modelo autorizado para Uber Black em São Paulo, Brasília, Curitiba, Belo Horizonte e Porto Alegre',
    },
    {
      icone: UberRJ,
      titulo: 'Aceito no Uber Black RJ e outros',
      descricao:
        'Modelo autorizado para Uber Black no Rio de Janeiro, Campinas, Salvador, Recife, Florianópolis, Goiânia, Fortaleza e Vitória',
    },
    {
      icone: Uber,
      titulo: 'Aceito no Uber Black SP, RJ e outros',
      descricao:
        'Modelo autorizado para Uber Black em São Paulo, Brasília, Curitiba, Belo Horizonte, Porto Alegre, Rio de Janeiro, Salvador, Recife, Florianópolis, Goiânia, Fortaleza e Vitória',
    },
    {
      icone: BadgePneus, // Nova badge de pneus
      titulo: 'Pneus em condição de rodagem',
    },
    {
      icone: BadgeInterior, // Nova badge de conservação do interior
      titulo: 'Bom estado de conservação interior',
    },
    {
      icone: BadgeGNV, // Nova badge de GNV
      titulo: 'Equipado com GNV',
    },
    {
      icone: BadgeBlindagem, // Nova badge de blindagem
      titulo: 'Veículo blindado',
      descricao: 'Blindagem documentada',
    },
  ];

  const trueBadgesKeys = Object.keys(BADGE_STATUS).filter(key => BADGE_STATUS[key]);

  const getTrueBadges = () => {
    // Definir ordem de prioridade das badges
    const badgeOrder = [
      'BadgeCautelar', // 1. Cautelar aprovada (mais alta prioridade)
      'BadgeLongarina', // 2. Longarina sem avarias
      'BadgeColunas', // 3. Coluna sem avarias
      'BadgeCambio', // 4. Câmbio sem apontamentos
      'BadgeScanner', // 5. Scanner sem apontamentos
      'BadgeInterior', // 6. Bom estado de conservação interior (NOVA)
      'BadgePneus', // 7. Pneus em condição de rodagem
      'BadgeBomKm', // 8. Boa km por ano
      'BadgeMargem', // 9. Margem alta revenda
      'BadgeRevenda', // 10. Giro rápido
      'BadgeUberBoothStates', // 11. Uber SP, RJ e outros
      'BadgeUberSP', // 12. Uber SP e outros
      'BadgeUberRJ', // 13. Uber RJ e outros
    ];

    // Aplicar regras de supressão
    let filteredBadges = Object.keys(BADGE_STATUS).filter(key => BADGE_STATUS[key]);

    // Regra 1: Se "Cautelar Aprovada" está presente, NÃO exibir "Longarina" e "Coluna"
    if (filteredBadges.includes('BadgeCautelar')) {
      filteredBadges = filteredBadges.filter(
        badge => !['BadgeLongarina', 'BadgeColunas'].includes(badge)
      );
    }

    // REMOVIDA: Regra 2 que estava causando o problema
    // As badges de scanner e transmissão agora serão exibidas individualmente
    // quando suas condições forem atendidas

    // Ordenar badges pela ordem de prioridade definida
    const orderedBadges = badgeOrder.filter(badge => filteredBadges.includes(badge));

    // Adicionar badges que não estão na ordem definida (fallback)
    const remainingBadges = filteredBadges.filter(badge => !badgeOrder.includes(badge));
    const finalBadges = [...orderedBadges, ...remainingBadges];

    return finalBadges.reduce((result, key) => {
      const badgeIndex = Object.keys(BADGE_STATUS).indexOf(key);
      if (badgeIndex !== -1 && BADGES[badgeIndex]) {
        result[key] = BADGES[badgeIndex];
      }
      return result;
    }, {});
  };

  const badgesToDisplay = getTrueBadges();

  const getVersionByFuel = useCallback(() => {
    let matched;

    if (!summary?.version) {
      return '-';
    }

    fuel.forEach(f => {
      if (
        summary.version
          .normalize('NFD')
          .replace(/\p{Mn}/gu, '')
          .toUpperCase()
          .includes(f)
      ) {
        matched = f.charAt(0).toUpperCase() + f.slice(1).toLowerCase();

        if (matched === 'Eletrico') {
          matched = 'Elétrico';
        }

        if (matched === 'Hibrido' || matched === 'Hybrid') {
          matched = 'Híbrido';
        }

        if (matched === 'Hibrido flex' || matched === 'Hybrid flex') {
          matched = 'Híbrido/Flex';
        }

        if (matched === 'Jetflex gasolina') {
          matched = 'Gasolina';
        }
      }
    });

    if (!summary?.summary) {
      return matched || '-';
    }

    if (summary.summary.toUpperCase().includes('GNV')) {
      return `${matched}/GNV`;
    }

    return matched || '-';
  }, [summary]);

  // const getHighlightsByManualAndSpareKey = useCallback(() => {
  //   const missingAll = highlights?.find(h => h.includes('MANUAL E CONJUNTO DE CHAVES AUSENTE'));
  //   const missingSpareKey = highlights?.find(h => h.includes('CONJUNTO DE CHAVES AUSENTE'));

  //   const missingManual = highlights?.find(
  //     h => h.includes('MANUAL AUSENTE') || h.includes('MANUAL ORIGINAL AUSENTE')
  //   );

  //   if (missingAll) {
  //     return 'Não';
  //   } else if (missingSpareKey && !missingManual) {
  //     return 'Não/Sim';
  //   } else if (!missingSpareKey && missingManual) {
  //     return 'Sim/Não';
  //   } else {
  //     return 'Sim';
  //   }
  // }, [highlights]);

  const getGear = useMemo(() => {
    if (summary?.version?.includes('MANUAL')) {
      return 'Manual';
    }

    return summary?.version?.includes('AUTOMATIZADO') ? 'Automatizado' : 'Automático';
  }, [summary]);

  window.addEventListener('resize', () => setSize(window.screen.width));

  return (
    <Container enabled={shouldShowFipeWebPrices}>
      <VehicleArea>
        {shouldShowFipeWebPrices && (
          <ReferencePrices marketPrice={marketPrice} webPrice={summary?.webPrice} />
        )}

        {trueBadgesKeys.length > 0 && (
          <Column>
            <BadgeAreaTitle>Destaques da oferta</BadgeAreaTitle>
            <BadgeArea>
              {Object.entries(badgesToDisplay).map(([key, badge]) => (
                <Column key={key}>
                  <Badge>
                    <BadgeIcon src={badge.icone} />
                    <BadgeContent>
                      <BadgeTitle>{badge.titulo}</BadgeTitle>
                      <BadgeDescription>{badge.descricao}</BadgeDescription>
                    </BadgeContent>
                  </Badge>
                  <Divider />
                </Column>
              ))}
            </BadgeArea>
          </Column>
        )}

        <ScoreLocation>
          <SpanRow>
            <TiLocation
              size={27}
              color="#80BEB0"
              style={{ verticalAlign: 'text-top', marginRight: '0.3em' }}
            />
            Retirada em {summary?.vehicleYardRegion ?? summary?.state}*
          </SpanRow>
        </ScoreLocation>

        <Row>
          <Column>
            <List>
              <ListItem>
                <span>Ano</span>
                <strong>{summary?.year}</strong>
              </ListItem>
              <ListItem>
                <span>Km</span>
                <strong>
                  {summary?.km?.toLocaleString('pt-BR', { minimumFractionDigits: 0 })}
                </strong>
              </ListItem>
              <ListItem>
                <span>Câmbio</span>
                <strong>{getGear}</strong>
              </ListItem>
              <ListItem>
                <span>Combustível</span>
                <strong>{getVersionByFuel()}</strong>
              </ListItem>
              <ListItem>
                <span>Cautelar</span>
                <strong>{injuctionNote}</strong>
              </ListItem>
            </List>
          </Column>

          <Column>
            <List>
              <ListItem>
                <span>Final da Placa</span>
                <strong>{String(summary?.plateNumber).substring(7)}</strong>
              </ListItem>
              <ListItem>
                <span>Emplacado em</span>
                <strong>{summary?.plateLocation}</strong>
              </ListItem>
              <ListItem>
                <span>Conjunto de chaves</span>
                <strong>{keySet}</strong>
              </ListItem>
              <ListItem>
                <span>Manual ou Livreto</span>
                <strong>{manualBooklet}</strong>
              </ListItem>
            </List>
          </Column>
        </Row>
      </VehicleArea>

      {props?.evaluationComment?.[0]?.value?.length >= 1 && (
        <div className="evaluation-section" style={{ marginTop: '1.4rem'}}>
          <div style={{ fontSize: '1rem' }}>
            <span style={{ marginLeft: '0.5rem', fontWeight: 'bolder' }}>💬 {props?.evaluationComment?.[0]?.label && `${props?.evaluationComment?.[0]?.label}:  `}</span>
            {props?.evaluationComment?.[0]?.value && ` ${props?.evaluationComment?.[0]?.value}`}&nbsp;
            {props?.evaluationComment?.[0]?.comment && ` - ${props?.evaluationComment?.[0]?.comment}`}
            <span style={{ marginLeft: '0.5rem', fontWeight: 'bolder' }}>
              💬 {props?.evaluationComment?.label && `${props?.evaluationComment?.label}:  `}
            </span>
            {props?.evaluationComment?.value && ` ${props?.evaluationComment?.value}`}&nbsp;
            {props?.evaluationComment?.comment && ` - ${props?.evaluationComment?.comment}`}
          </div>
        </div>
      )}
      <DutLabel>
        {updatedAuction?.summary?.documentResearch?.dutLabel ||
          updatedAuction?.documentResearch?.dutLabel}
      </DutLabel>
    </Container>
  );
};
